import {Dialog, DialogTrigger, Modal} from "react-aria-components";
import MobileDuoFilterModal from "./MobileDuoFilterModal";
import {useState, useCallback} from "react";
import ModalBody from "../../../../../_components/ModalBody";
import ModalOverlay from "../../../../../_components/ModalOverlay";
import CampusSelectorButton from "@/app/(withHeaderAndFooter)/(sellPages)/courses/course/components/CampusSelectorButton";
import {CampusSelectorProps} from "./CampusSelector";
import {DayOfWeekDropdownProps} from "./DayOfWeekDropdown";

interface MobileDuoFilterProps
	extends CampusSelectorProps,
		DayOfWeekDropdownProps {}

const MobileDuoFilter: React.FC<MobileDuoFilterProps> = ({
	setCurrentCampuses,
	...props
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const {currentCampuses, allCampusesById} = props;

	const onCampusSelected = useCallback(
		(campusId: string) => {
			setIsOpen(false);
			setCurrentCampuses(new Set([campusId]));
		},
		[setCurrentCampuses]
	);

	return (
		<div className="md:hidden">
			<DialogTrigger>
				<CampusSelectorButton
					currentCampuses={currentCampuses}
					allCampusesById={allCampusesById}
					buttonProps={{
						onPress: () => setIsOpen(true),
					}}
				/>
				<ModalOverlay isDismissable isOpen={isOpen} onOpenChange={setIsOpen}>
					<Modal className="h-full w-full overflow-auto">
						<Dialog>
							<ModalBody
								onClose={() => setIsOpen(false)}
								className="h-full w-full px-0 pt-8"
							>
								<MobileDuoFilterModal
									onCampusSelected={onCampusSelected}
									{...props}
								/>
							</ModalBody>
						</Dialog>
					</Modal>
				</ModalOverlay>
			</DialogTrigger>
		</div>
	);
};

export default MobileDuoFilter;
